import { RESULTS_LIMIT } from 'apps/chat/constants/LiveChatSearch'
import { chatApi } from 'shared/api/requests/chat'
import { SearchMessageResponse } from 'shared/api/requests/chat/search/schemas'
import { createAsyncAction } from 'shared/lib/redux'

interface FetchSearchResultsArgs {
  query: string
  limit?: number
}

export const fetchSearchResults = createAsyncAction<SearchMessageResponse, FetchSearchResultsArgs>(
  'chat/search/fetchResults',
  async ({ query, limit = RESULTS_LIMIT }) => {
    const response = await chatApi.search.searchMessages({
      query: {
        text: query,
        limit,
      },
    })

    return response.data
  },
  {
    errorMarkupOptions: { scope: 'livechat', section: 'search' },
  },
)

export const fetchNextSearchResults = createAsyncAction<
  SearchMessageResponse,
  FetchSearchResultsArgs
>(
  'chat/search/fetchNextResults',
  async ({ query, limit = RESULTS_LIMIT }, { getState }) => {
    const { limiter } = getState().chat.search

    const response = await chatApi.search.searchMessages({
      query: {
        text: query,
        limit,
        limiter,
      },
    })

    return response.data
  },
  {
    errorMarkupOptions: { scope: 'livechat', section: 'search' },
  },
)
